<script lang="ts">
	import { onMount } from 'svelte';
	import { hasReference, withSlugs } from '$lib/utils/storyblok/page';
	import { page } from '$app/state';
	import type { ISbStoryData } from '@storyblok/js';
	import Blok from '../blok.svelte';
	import { storyblok } from '$lib/state/storyblok.svelte';
	interface GlobalSiteBanner {
		enable: boolean;
		banner: ISbStoryData[];
		pages: string[];
	}

	let siteBanner: ISbStoryData<GlobalSiteBanner>['content'];

	onMount(async () => {
		const response = await storyblok.client.getStory<GlobalSiteBanner>('globals/site-banner', {
			resolve_relations: 'pages'
		});

		siteBanner = withSlugs(response).content;
	});
</script>

{#if siteBanner?.enable && (siteBanner?.pages?.length === 0 || hasReference(siteBanner?.pages, page.url.pathname))}
	{#each siteBanner?.banner || [] as banner}
		<Blok content={banner} />
	{/each}
{/if}
